import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import SEO from '../components/seo'
import Layout from '../components/layout'
import Container from '../components/container'
import Hero from '../components/sections/hero'
import lines from '../images/diagonal-pattern-medium.svg'
import { sliceBuilder } from '../utilities/slices'
import styles from './index.module.scss'

const IndexPage = ({
  data: {
    prismicHome: {
      data: {
        black_box_text,
        title,
        sub_title,
        intro,
        call_to_action_text,
        call_to_action_link,
        hero_background_color,
        hero_background_image,
        hero_background_size,
        hero_background_alignment_x,
        hero_background_alignment_y,
        canonical,
        meta_title,
        meta_description,
        slices,
        cards,
      }
    }
  }
}) => {
  const [ renderedSlices, setRenderedSlices ] = useState( [] )

  useEffect( () => {
    sliceBuilder( slices ).then( finalSlices => setRenderedSlices( finalSlices ) )
  }, [ slices ] )

  return (
    <Layout>
      <SEO
        title={ meta_title.text }
        description={ meta_description }
        canonicalUrl={ canonical && canonical.url }
        cards={ cards }
      />

      <Hero
        title={ title.text }
        subTitle={ sub_title.text }
        intro={ intro.text && intro.html }
        link={ call_to_action_link.url }
        linkText={ call_to_action_text }
        linkNewTab={ call_to_action_link.target === '_blank' }
        linkExternal={ call_to_action_link.link_type === 'Web' }
        backgroundColor={ hero_background_color }
        backgroundImage={ hero_background_image && hero_background_image.fluid }
        backgroundImageSize={ hero_background_size }
        backgroundImagePositionX={ hero_background_alignment_x }
        backgroundImagePositionY={ hero_background_alignment_y }
        colSpan={ 6 }
        className={ styles.hero }
        marginBottom={ false }
      />

      <section className={ styles.sectionOne }>
        <Container className={ styles.container }>
          <p className={ styles.blackBox }>{ black_box_text }</p>

          <img src={ lines } alt="" className={ styles.lines } />
        </Container>
      </section>

      { renderedSlices && renderedSlices.map( slice => slice ) }
    </Layout>
  )
}

export default IndexPage

export const IndexPageQuery = graphql`
  {
    prismicHome {
      uid
      data {
        black_box_text
        title {
          text
        }
        sub_title {
          text
        }
        sub_title {
          text
        }
        intro {
          text
          html
        }
        call_to_action_text
        call_to_action_link {
          url
          target
          link_type
        }
        call_to_action_text
        call_to_action_link {
          url
          target
          link_type
        }
        hero_background_color
        hero_background_image {
          fluid {
            ...GatsbyPrismicImageFluid
          }
        }
        hero_background_size
        hero_background_alignment_x
        hero_background_alignment_y
        canonical {
          url
        }
        meta_title {
          text
        }
        meta_description
        slices {
          ... on PrismicHomeSlicesTabs {
            slice_type
            primary {
              tabs_accordion_on_mobile
              tabs_container_fluid
              tabs_margin_bottom
              tabs_text_color
              tabs_background_color
            }
            items {
              tabs_title
              tabs_content {
                text
                html
              }
              tabs_cta_link {
                url
                type
                target
              }
              tabs_cta_link_text
              tabs_cta_link_arrow_type
              tabs_cta_link_arrow_position
            }
          }
          ... on PrismicHomeSlicesStatBoxes {
            slice_type
            primary {
              stat_boxes_per_row
              stat_boxes_margin_bottom
              stat_boxes_container_fluid
              stat_boxes_text_color
              stat_boxes_background_color
            }
            items {
              stat_boxes_stat
              stat_boxes_text
            }
          }
          ... on PrismicHomeSlicesTextImageCta {
            slice_type
            primary {
              text_image_cta_text
              text_image_cta_image {
                fluid {
                  ...GatsbyPrismicImageFluid
                }
              }
              text_image_cta_link {
                url
                type
                target
              }
              text_image_cta_link_text
              text_image_cta_link_arrow_type
              text_image_cta_link_arrow_position
              text_image_cta_container_fluid
              text_image_cta_margin_bottom
              text_image_cta_text_color
              text_image_cta_background_color
            }
          }
        }
        cards {
          ... on PrismicHomeCardsGeneralCard {
            slice_type
            primary {
              general_type
              general_locale
              general_title {
                text
              }
              general_description
              general_image {
                url
              }
            }
          }

          ... on PrismicHomeCardsTwitterCard {
            slice_type
            primary {
              twitter_card_type
              twitter_handle
              twitter_title {
                text
              }
              twitter_description
              twitter_image {
                url
              }
            }
          }
        }
      }
    }
  }
`
